import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    component: () => import('@/components/layout/main.vue'),
    children: [
      { path: '', name: 'home', component: () => import('@/views/HomeView.vue'), meta: { title: '齿记口腔 — Wish you spend everyday with a smile' } },
      { path: 'doctor-team', name: 'doctor-team', component: () => import('@/views/DoctorTeamView.vue'), meta: { title: '医生团队｜齿记口腔' } },
      { path: 'pricing', name: 'pricing', component: () => import('@/views/PricingView.vue'), meta: { title: '价目表｜齿记口腔' } },
      { path: 'process', name: 'process', component: () => import('@/views/ProcessView.vue'), meta: { title: '流程及注意事项｜齿记口腔' } },
      { path: 'service-detail', name: 'service-detail', component: () => import('@/views/ServiceDetailView.vue'), meta: { title: '业务项目｜齿记口腔' } },
      { path: 'news', name: 'news', component: () => import('@/views/NewsView.vue'), meta: { title: '齿记资讯｜齿记口腔' } },
      { path: 'news-detail', name: 'news-detail', component: () => import('@/views/NewsDetailView.vue'), meta: { title: '资讯详情｜齿记口腔' } }
    ]
  },
  { path: '/consultation', name: 'consultation', component: () => import('@/views/ConsultationView.vue'), meta: { title: '在线咨询｜齿记口腔' } },
  { path: '/:pathMatch(.*)*', redirect: '/' }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.hash === '#top') return { top: 0, behavior: 'smooth' }
    if (to.hash) return { el: to.hash, top: 50, behavior: 'smooth' }
    return { top: 0 }
  }
})

router.afterEach((to) => {
  if (to.meta.title) document.title = to.meta.title
})

export default router
